import { useEffect, useMemo, useState } from 'react'
import { Button, Col, Form, Modal, Row, Spinner } from 'react-bootstrap'
import SweetAlert from 'react-bootstrap-sweetalert'
import DataTable from 'react-data-table-component'
import { FaSearch } from 'react-icons/fa'
import { AsyncPaginate } from 'react-select-async-paginate'
import KapalService from '../../../../services/kapal/KapalService'
import PbUmkuService from '../../../../services/pbumku/PbumkuService'
import { getCurrentDateFormatted, getCurrentDateTimeFormattedPlusNYears } from '../../../../utilities/Utils'
import ModalInspeksiChecklistHasil from './ModalInspeksiChecklistHasil'
import MasterService from '../../../../services/master/MasterService'

const ModalApproval = ({ showApproval, handleCloseApproval, dataPpmKapal, dataDisposisi, reloadList, isEdit }) => {

    let kapalService = useMemo(() => new KapalService(), [])
    let pbumkuService = useMemo(() => new PbUmkuService(), [])
    let masterService = useMemo(() => new MasterService(), [])

    const currentDate = new Date()
    const currentYear = currentDate.getFullYear()
    const year2D = currentYear.toString().slice(-2)

    const columnsEvaluasi = [
        {
            name: 'Nama',
            cell: row => ((localStorage.getItem("role") === '6' || localStorage.getItem("role") === '1' || localStorage.getItem('isMandatoryPrimer') === 'Y') ? row['nmEvaluator'] : "***")
        },
        {
            name: 'Jenis Komoditi',
            cell: row => <ViewKomoditi idInspeksiEvaluasi={row['idInspeksiEvaluasi']} nomorAjuKapal={row['nomorAjuKapal']} />
        },
        {
            name: 'Catatan Tim Teknis',
            cell: row => row['catatanEvaluator']
        },
        {
            name: 'Usulan Grade',
            cell: row => row['gradeUsul']
        },
        {
            name: 'Tanggal Evaluasi',
            cell: row => row['tglEvaluasi']
        }
    ]
    const [listEvaluasi, setListEvaluasi] = useState(null)
    const [loading, setLoading] = useState(false)
    const [isUnder5GT, setIsUnder5GT] = useState(null)
    const [idInspeksi, setIdInspeksi] = useState(null)
    const [listRekom, setListRekom] = useState(null)
    const [dataInspeksi, setDataInspeksi] = useState(null)
    const [masterKapal, setMasterKapal] = useState(null)
    const [kotaTerbit, setKotaTerbit] = useState(null)

    const columnsRekomendasi = [
        {
            name: 'Nama',
            cell: row => ((localStorage.getItem("role") === '6' || localStorage.getItem("role") === '1' || localStorage.getItem('isMandatoryPrimer') === 'Y') ? row['nmRekom'] : "***")
        },
        {
            name: 'Jenis Komoditi',
            cell: row => <ViewKomoditiRekom idInspeksiRekom={row['idInspeksiRekom']} nomorAjuKapal={row['nomorAjuKapal']} />
        },
        {
            name: 'Catatan Rekomendasi',
            cell: row => row['catatanRekom']
        },
        {
            name: 'Grade',
            cell: row => row['gradeRekom']
        },
        {
            name: 'Tanggal Rekomendasi',
            cell: row => row['tglRekom']
        }
    ]

    useEffect(() => {
        if (!dataPpmKapal) return
        const fetchAllData = async () => {
            setLoading(true)
            try {
                const resDataInspeksi = await kapalService.getInspeksiData(dataPpmKapal.nomorAjuKapal)
                if (resDataInspeksi) {
                    setIdInspeksi(resDataInspeksi.data.idInspeksi)
                    setDataInspeksi(resDataInspeksi.data)

                    const resMasterKapal = await kapalService.getMasterKapalById(dataPpmKapal.idKapal)
                    setMasterKapal(resMasterKapal.data)

                    const resEvaluasi = await kapalService.listEvaluasiTeknisByIdInspeksi(resDataInspeksi.data.idInspeksi)
                    setListEvaluasi(resEvaluasi.data.data)

                    setIsUnder5GT(dataPpmKapal.ukuranKapal <= 5 ? 'Y' : 'T')

                    const resRekom = await kapalService.listRekomTeknis(resDataInspeksi.data.idInspeksi)
                    setListRekom(resRekom.data.data)
                    setValueGrade(resRekom.data.data[0].gradeRekom)

                    const resRekomProduk = await kapalService.listJenisKomoditiRekomTeknis(dataPpmKapal.nomorAjuKapal)
                    setValueJenisKomoditi(resRekomProduk.data.data)

                    const resApproval = await kapalService.listApprovalTeknis(resDataInspeksi.data.idInspeksi)
                    if (resApproval.data.data.length > 0) {
                        const dataApproval = resApproval.data.data[0]

                        const optKesimpulan = await kapalService.getKesimpulanById(dataApproval.idKesimpulan)
                        setValueApprovalOpt(optKesimpulan.data)

                        const resPegawai = await pbumkuService.getPenandatanganByNip(dataApproval.nipApproval)
                        setValuePegawaiOpt(resPegawai.data)

                        setValueCatatan(dataApproval.catatanApproval)
                        setValueTglApprove(dataApproval.tglApproval)
                        // setValueNomorSert(dataApproval.nomorSertifikat)

                        const resKota = await masterService.getKotaById(dataPpmKapal.kdKota)
                        setKotaTerbit(resKota?.data?.uraianKota ?? 'JAKARTA')
                    }
                }
            } catch (error) {

            }
            setLoading(false)
        }
        fetchAllData()
    }, [kapalService, dataPpmKapal, pbumkuService, masterService])

    const [showHasilInspeksi, setShowHasilInspeksi] = useState(false)
    const handleCloseHasilInspeksi = () => setShowHasilInspeksi()
    const ViewHasilInspeksi = () => {
        setShowHasilInspeksi(true)
    }

    const [valueTglApprove, setValueTglApprove] = useState(getCurrentDateFormatted())
    const [valueCatatan, setValueCatatan] = useState(null)
    const [valuePegawaiOpt, setValuePegawaiOpt] = useState(null)
    // const [valueNomorSert, setValueNomorSert] = useState(null)
    const [valueGrade, setValueGrade] = useState(null)
    const [valueJenisKomoditi, setValueJenisKomoditi] = useState(null)

    // const handleChangeNomorSert = e => {
    //     setValueNomorSert(e.target.value)
    // }

    const [valueApprovalOpt, setValueApprovalOpt] = useState(null)
    const onChangeApproval = e => {
        setValueApprovalOpt(e)
    }

    async function loadOptionApproval(search, loadedOption, { page = 1 }) {
        const response = await kapalService.listKesimpulan(8)
        return {
            options: response.data,
        }
    }

    async function loadOptionPegawai(search, loadedOption, { page = 1 }) {
        const response = await pbumkuService.listPenandatangan(search, page, 10)
        return {
            options: response.data.data,
            hasMore: response.data.data.length >= 10,
            additional: {
                page: page + 1
            }
        }
    }
    const onChangePegawai = e => {
        setValuePegawaiOpt(e)
    }
    const handleChangeTglApprove = e => {
        setValueTglApprove(e.target.value)
    }
    const handleChangeCatatan = e => {
        setValueCatatan(e.target.value)
    }

    const [showConfirmSimpan, setShowConfirmSimpan] = useState(false)
    const handleCloseConfirmSimpan = () => setShowConfirmSimpan(false)
    const handleClickConfirmSimpan = () => {
        setShowConfirmSimpan(true)
    }

    const [loadingSimpan, setLoadingSimpan] = useState(false)
    const [showSimpanSuccess, setShowSimpanSuccess] = useState(false)
    const [showSimpanFailed, setShowSimpanFailed] = useState(false)

    const handleCloseSuccess = () => {
        setShowSimpanSuccess(false)
        reloadList(0, 10, dataPpmKapal.nomorAjuKapal)
    }

    const handleCloseFailed = () => {
        setShowSimpanFailed(false)
        reloadList(0, 10, dataPpmKapal.nomorAjuKapal)
    }

    const handleClickSimpan = async () => {
        setLoadingSimpan(true)
        try {
            const respNomorSert = await pbumkuService.ambilNomorService('SERT_KAPAL', 'P', currentYear, localStorage.getItem('username'))
            let nomorSertifikat = respNomorSert.data.uraianPusat + '-' + dataPpmKapal.kdProp + '-' + year2D + respNomorSert.data.nomorUrut

            let jsonApproval = {
                idInspeksi: idInspeksi,
                nomorAjuKapal: dataPpmKapal.nomorAjuKapal,
                nipApproval: valuePegawaiOpt.nipPenandatangan,
                nmApproval: valuePegawaiOpt.namaPenandatangan,
                tglApproval: valueTglApprove,
                catatanApproval: valueCatatan,
                idKesimpulan: valueApprovalOpt.idKesimpulan,
                gradeRekom: valueGrade,
                // nomorSertifikat: valueNomorSert,
                nomorSertifikat: nomorSertifikat,
                createdBy: localStorage.getItem('userId'),
                createdDate: new Date(),
            }

            const resApproval = await kapalService.saveApprovalTeknis(jsonApproval)
            if (resApproval.data.kode === '200') {
                if (valueApprovalOpt.idKesimpulan === 11) {
                    let dataSert = {
                        nomorAjuKapal: dataPpmKapal.nomorAjuKapal,
                        // nomorSertifikat: valueNomorSert,
                        nomorSertifikat: nomorSertifikat,
                        namaKapal: dataPpmKapal.namaKapal,
                        alamatPemilik: masterKapal.alamatPemilik,
                        ukuranKapal: dataPpmKapal.ukuranKapal,
                        jenisKapal: dataPpmKapal.jenisKapal,
                        grade: valueGrade,
                        tanggalTerbit: valueTglApprove,
                        berlakuSampai: getCurrentDateTimeFormattedPlusNYears(valueTglApprove, 4),
                        nipTtd: localStorage.getItem('isMandatoryPrimer') === 'Y' ? valuePegawaiOpt.nipPenandatangan : '196605141993032001',
                        namaTtd: localStorage.getItem('isMandatoryPrimer') === 'Y' ? valuePegawaiOpt.namaPenandatangan : 'ISHARTINI',
                        jabatanTtd: localStorage.getItem('isMandatoryPrimer') === 'Y' ? valuePegawaiOpt.jabatanPenandatangan : 'KEPALA BADAN PENGENDALIAN DAN PENGAWASAN MUTU HASIL KELAUTAN DAN PERIKANAN',
                        createdDate: new Date(),
                        createdBy: localStorage.getItem('userId'),
                        kotaTerbit: localStorage.getItem('isMandataryPrimer') === 'Y' ? kotaTerbit : 'JAKARTA',
                        tanggalInspeksi: dataInspeksi.tglInspeksi,
                        stsTte: 0
                        // idJenisKomoditi: valueJenisKomoditi
                    }
                    const resSert = await kapalService.saveKapalSertifikat(dataSert)
                    if (resSert.data.kode === '200') {
                        valueJenisKomoditi.map(async (komoditi) => {
                            let jsonApprovalProduk = {
                                idInspeksiApproval: resApproval.data.id,
                                idInspeksi: idInspeksi,
                                nomorAjuKapal: dataPpmKapal.nomorAjuKapal,
                                idKomoditi: komoditi.idJenisKomoditi,
                                createdDate: new Date(),
                                createdBy: localStorage.getItem('userId'),
                            }
                            await kapalService.saveApprovalTeknisProduk(jsonApprovalProduk)

                            let jsonSertProduk = {
                                idSert: resSert.data.id,
                                nomorAjuKapal: dataPpmKapal.nomorAjuKapal,
                                idKomoditi: komoditi.idJenisKomoditi
                            }
                            await kapalService.saveKapalSertifikatProduk(jsonSertProduk)
                        })
                    }
                }

                let dataDispo = {
                    ...dataDisposisi,
                    noTugas: 'APP-' + dataPpmKapal.nomorAjuKapal,
                    tglTugas: new Date()
                }
                await kapalService.savePenugasan(dataDispo)


                let dataStatusNext = {
                    nomorAjuKapal: dataPpmKapal.nomorAjuKapal,
                    kodeStatus: valueApprovalOpt.kdStatusNext,
                    waktuStatus: new Date(),
                    createdBy: localStorage.getItem('userId')
                }
                await kapalService.saveKapalStatus(JSON.stringify(dataStatusNext))

                let jsonKapal = {
                    ...dataPpmKapal,
                    kodeStatus: valueApprovalOpt.kdStatusNext,
                    updatedBy: localStorage.getItem('userId'),
                    updatedDate: new Date()
                }
                await kapalService.saveKapalHeader(jsonKapal)

                setShowConfirmSimpan(false)
                setShowSimpanSuccess(true)

            } else {
                setShowConfirmSimpan(false)
                setShowSimpanFailed(true)
            }

        } catch (error) {
            setShowConfirmSimpan(false)
            setShowSimpanFailed(true)
        }
        setLoadingSimpan(false)
    }

    const handleClickClose = () => {
        handleCloseApproval()
    }

    return (
        <>
            <Modal
                show={showApproval}
                onHide={handleCloseApproval}
                centered
                size='xl'
                backdrop='static'
                scrollable={true}
            >
                <Modal.Header closeButton><Modal.Title><h5>Persetujuan Penerbitan</h5></Modal.Title></Modal.Header>
                <Modal.Body>
                    <div className='row'>
                        <div className='col-12'>
                            <Form>
                                <Form.Group as={Row} className="form-group">
                                    <Form.Label column sm="2" className="control-label align-self-center mb-0" htmlFor="searchNib">Nomor Aju Kapal</Form.Label>
                                    <Col sm="6">
                                        <Form.Control type="text" placeholder="NIB" className="form-control-sm" value={dataPpmKapal.nomorAjuKapal} disabled />
                                    </Col>
                                </Form.Group>
                            </Form>
                        </div>
                    </div>
                    <div className='row'>
                        <div className='col-6'>
                            <Form>
                                <Form.Group as={Row} className="form-group">
                                    <Form.Label column sm="4" className="control-label align-self-center mb-0" htmlFor="searchNib">Nama Kapal</Form.Label>
                                    <Col sm="8">
                                        <Form.Control type="text" placeholder="Nama Kapal" className="form-control-sm" value={dataPpmKapal.namaKapal} disabled />
                                    </Col>
                                </Form.Group>
                            </Form>
                        </div>
                        <div className='col-6'>
                            <Form>
                                <Form.Group as={Row} className="form-group">
                                    <Form.Label column sm="3" className="control-label align-self-center mb-0" htmlFor="searchNib">Ukuran Kapal</Form.Label>
                                    <Col sm="2">
                                        <Form.Control type="text" placeholder="Nama Kapal" className="form-control-sm" value={dataPpmKapal.ukuranKapal} disabled />
                                    </Col>
                                    <Form.Label column sm="2" className="control-label align-self-center mb-0" htmlFor="searchNib">GT</Form.Label>
                                </Form.Group>
                            </Form>
                        </div>
                    </div>
                    <div className='row'>
                        <div className='col-12'>
                            <Form>
                                <Form.Group as={Row} className="form-group">
                                    <Form.Label column sm="2" className="control-label align-self-center mb-0" htmlFor="searchNib">Hasil Inspeksi</Form.Label>
                                    <Col sm="8">
                                        <Button size='sm' variant='outline-info' onClick={() => ViewHasilInspeksi()}><FaSearch />{' '}Lihat Hasil Inspeksi</Button>
                                    </Col>
                                </Form.Group>
                            </Form>
                        </div>
                    </div>
                    <SummaryChecklist nomorAjuKapal={dataPpmKapal.nomorAjuKapal} isUnde5Gt={isUnder5GT} />
                    <div className='row'>
                        <div className='col-12'>
                            <Form>
                                <Form.Group as={Row} className="form-group">
                                    <Form.Label column sm="2" className="control-label align-self-center mb-0" htmlFor="searchNib"><b>Evaluasi Tim Teknis</b></Form.Label>
                                    <Col sm="2">
                                    </Col>
                                </Form.Group>
                            </Form>
                        </div>
                    </div>
                    <div className='row'>
                        <div className='col-12'>
                            <div className="table-responsive border-bottom my-2">
                                {(loading && <Spinner />)}
                                {
                                    listEvaluasi &&
                                    <DataTable
                                        customStyles={{ headCells: { style: { 'background-color': '#00acee', 'color': 'white' } } }}
                                        columns={columnsEvaluasi}
                                        data={listEvaluasi}
                                        highlightOnHover
                                        persistTableHead={true}
                                    />
                                }
                            </div>
                        </div>
                    </div>
                    <div className='row'>
                        <div className='col-12'>
                            <Form>
                                <Form.Group as={Row} className="form-group">
                                    <Form.Label column sm="2" className="control-label align-self-center mb-0" htmlFor="searchNib"><b>Rekomendasi</b></Form.Label>
                                    <Col sm="2">
                                    </Col>
                                </Form.Group>
                            </Form>
                        </div>
                    </div>
                    <div className='row'>
                        <div className='col-12'>
                            <div className="table-responsive border-bottom my-2">
                                {(loading && <Spinner />)}
                                {
                                    listRekom &&
                                    <DataTable
                                        customStyles={{ headCells: { style: { 'background-color': '#00acee', 'color': 'white' } } }}
                                        columns={columnsRekomendasi}
                                        data={listRekom}
                                        highlightOnHover
                                        persistTableHead={true}
                                    />
                                }
                            </div>
                        </div>
                    </div>
                    <div className='row'>
                        <div className='col-12'>
                            <Form>
                                <Form.Group as={Row} className="form-group">
                                    <Form.Label column sm="2" className="control-label align-self-center mb-0" htmlFor="searchNib"><b>Persetujuan</b></Form.Label>
                                    <Col sm="8">
                                        <AsyncPaginate
                                            loadOptions={loadOptionApproval}
                                            value={valueApprovalOpt}
                                            getOptionValue={(option) => option.idKesimpulan}
                                            getOptionLabel={(option) => option.urKesimpulan}
                                            additional={{
                                                page: 0,
                                            }}
                                            onChange={onChangeApproval}
                                            isDisabled={!isEdit}
                                        />
                                    </Col>
                                </Form.Group>
                            </Form>
                        </div>
                    </div>
                    <div className='row'>
                        <div className='col-12'>
                            <Form>
                                <Form.Group as={Row} className="form-group">
                                    <Form.Label column sm="2" className="control-label align-self-center mb-0" htmlFor="searchNib">Tanggal Disetujui</Form.Label>
                                    <Col sm="4">
                                        <Form.Control type="date" placeholder="Tanggal" className="form-control-sm" value={valueTglApprove} onChange={handleChangeTglApprove} disabled={!isEdit} />
                                    </Col>
                                </Form.Group>
                            </Form>
                        </div>
                    </div>
                    {/* <div className='row'>
                        <div className='col-12'>
                            <Form>
                                <Form.Group as={Row} className="form-group">
                                    <Form.Label column sm="2" className="control-label align-self-center mb-0" htmlFor="searchNib">Nomor Sertifikat</Form.Label>
                                    <Col sm="8">
                                        <Form.Control type="text" placeholder="Nomor Sertifikat" className="form-control-sm" value={valueNomorSert} onChange={handleChangeNomorSert} disabled={!isEdit} />
                                    </Col>
                                </Form.Group>
                            </Form>
                        </div>
                    </div> */}
                    <div className='row'>
                        <div className='col-12'>
                            <Form>
                                <Form.Group as={Row} className="form-group">
                                    <Form.Label column sm="2" className="control-label align-self-center mb-0" htmlFor="searchNib">Pejabat Persetujuan</Form.Label>
                                    <Col sm="8">
                                        <AsyncPaginate
                                            loadOptions={loadOptionPegawai}
                                            value={valuePegawaiOpt}
                                            getOptionValue={(option) => option.nipPenandatangan}
                                            getOptionLabel={(option) => option.nipPenandatangan + ' - ' + option.namaPenandatangan}
                                            additional={{
                                                page: 0,
                                            }}
                                            onChange={onChangePegawai}
                                            isDisabled={!isEdit}
                                        />
                                    </Col>
                                </Form.Group>
                            </Form>
                        </div>
                    </div>
                    <div className='row'>
                        <div className='col-12'>
                            <Form>
                                <Form.Group as={Row} className="form-group">
                                    <Form.Label column sm="2" className="control-label align-self-center mb-0" htmlFor="searchNib">Catatan</Form.Label>
                                    <Col sm="8">
                                        <Form.Control as="textarea" rows={5} placeholder="Catatan" className="form-control-sm" value={valueCatatan} onChange={handleChangeCatatan} disabled={!isEdit} />
                                    </Col>
                                </Form.Group>
                            </Form>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    {dataPpmKapal.kodeStatus === '027' && (localStorage.getItem("role") === "6" || localStorage.getItem('isMandatoryPrimer') === 'Y') && <Button variant="primary" size="sm" onClick={() => handleClickConfirmSimpan()}>Simpan</Button>}{' '}
                    <Button variant="danger" size="sm" onClick={() => handleClickClose()}>Batal</Button>
                </Modal.Footer>
            </Modal>
            <ModalInspeksiChecklistHasil showHasilInspeksi={showHasilInspeksi} handleCloseHasilInspeksi={handleCloseHasilInspeksi} dataPpmKapal={dataPpmKapal} />
            {
                showConfirmSimpan &&
                <SweetAlert
                    title="Simpan Persetujuan Penerbitan?"
                    warning
                    showCancel
                    confirmBtnText={
                        loadingSimpan ? (
                            <>
                                <Spinner animation="border" size="sm" className="me-2" />
                                Proses Simpan...
                            </>
                        ) : (
                            "Simpan"
                        )
                    }
                    confirmBtnBsStyle="primary"
                    cancelBtnText="Batal"
                    cancelBtnBsStyle="secondary"
                    onConfirm={handleClickSimpan}
                    onCancel={handleCloseConfirmSimpan}
                    focusCancelBtn
                    btnSize="sm"
                    disabled={loadingSimpan}
                    reverseButtons
                >
                    {loadingSimpan && (
                        <div className="text-center">
                            <Spinner animation="border" variant="primary" />
                            <p className="mt-2">Proses Simpan data, harap tunggu...</p>
                        </div>
                    )}
                </SweetAlert>
            }
            {
                showSimpanSuccess &&
                <SweetAlert
                    success
                    title="Simpan Data Berhasil"
                    onConfirm={handleCloseSuccess}
                    btnSize="sm"
                />
            }
            {
                showSimpanFailed &&
                <SweetAlert
                    danger
                    title="Simpan Data Gagal"
                    onConfirm={handleCloseFailed}
                    btnSize="sm"
                    timeout={2000}
                />
            }
        </>
    )
}

const ViewKomoditi = ({ idInspeksiEvaluasi, nomorAjuKapal }) => {
    let kapalService = useMemo(() => new KapalService(), [])

    const [valueKomoditi, setValueKomoditi] = useState(null)

    useEffect(() => {
        if (!idInspeksiEvaluasi && !nomorAjuKapal) return
        const fetchAllData = async () => {
            try {
                const resEvalTeknisProduk = await kapalService.listEvaluasiTeknisProduk(idInspeksiEvaluasi, nomorAjuKapal)
                const resJenisKomoditi = await kapalService.listJenisKomoditi(null, 0, 20)
                const optionsJenis = resJenisKomoditi.data.data
                const mappedSelected = resEvalTeknisProduk.data.data.map(item => {
                    const found = optionsJenis.find(
                        opt => (opt.idJenisKomoditi === item.idJenisKomoditi || opt.idJenisKomoditi === item.idKomoditi)
                    );

                    if (!found) return null; // handle jika tidak ketemu

                    return {
                        idJenisKomoditi: found.idJenisKomoditi,
                        urJenisKomoditi: found.urJenisKomoditi,
                        urJenisKomoditiEn: found.urJenisKomoditiEn
                    }
                }).filter(Boolean)
                setValueKomoditi(mappedSelected)

            } catch (error) {

            }
        }
        fetchAllData()
    }, [kapalService, nomorAjuKapal, idInspeksiEvaluasi])

    return (
        <div className='row'>
            {
                valueKomoditi && valueKomoditi.map((item, idx) => {
                    return <div className='col-12' key={idx}><b>{item.urJenisKomoditi}</b> ({item.urJenisKomoditiEn})<br /></div>
                })
            }
        </div>
    )
}

const ViewKomoditiRekom = ({ idInspeksiRekom, nomorAjuKapal }) => {
    let kapalService = useMemo(() => new KapalService(), [])

    const [valueKomoditi, setValueKomoditi] = useState(null)

    useEffect(() => {
        if (!idInspeksiRekom && !nomorAjuKapal) return
        const fetchAllData = async () => {
            try {
                const resEvalTeknisProduk = await kapalService.listRekomTeknisProduk(idInspeksiRekom, nomorAjuKapal)
                const resJenisKomoditi = await kapalService.listJenisKomoditi(null, 0, 20)
                const optionsJenis = resJenisKomoditi.data.data
                const mappedSelected = resEvalTeknisProduk.data.data.map(item => {
                    const found = optionsJenis.find(
                        opt => (opt.idJenisKomoditi === item.idJenisKomoditi || opt.idJenisKomoditi === item.idKomoditi)
                    );

                    if (!found) return null; // handle jika tidak ketemu

                    return {
                        idJenisKomoditi: found.idJenisKomoditi,
                        urJenisKomoditi: found.urJenisKomoditi,
                        urJenisKomoditiEn: found.urJenisKomoditiEn
                    }
                }).filter(Boolean)
                setValueKomoditi(mappedSelected)

            } catch (error) {

            }
        }
        fetchAllData()
    }, [kapalService, nomorAjuKapal, idInspeksiRekom])

    return (
        <div className='row'>
            {
                valueKomoditi && valueKomoditi.map((item, idx) => {
                    return <div className='col-12' key={idx}><b>{item.urJenisKomoditi}</b> ({item.urJenisKomoditiEn})<br /></div>
                })
            }
        </div>
    )
}


const SummaryChecklist = ({ nomorAjuKapal, isUnde5Gt }) => {

    let kapalService = useMemo(() => new KapalService(), [])
    const [dataSummary, setDataSummary] = useState(null)

    useEffect(() => {
        const fetchAllData = async () => {
            try {
                let response
                if (isUnde5Gt === 'Y') {
                    response = await kapalService.getSummaryChecklistSA(nomorAjuKapal)
                } else {
                    response = await kapalService.getSummaryChecklist(nomorAjuKapal)
                }
                setDataSummary(response.data)
            } catch (error) {

            }
        }
        fetchAllData()
    }, [kapalService, nomorAjuKapal, isUnde5Gt])

    return (
        <>
            {
                isUnde5Gt === 'Y' && dataSummary &&
                <div className='row'>
                    <div className='col-2'>
                        <Form>
                            <Form.Group as={Row} className="form-group">
                                <Form.Label column sm="4" className="control-label align-self-center mb-0" htmlFor="searchNib">Total</Form.Label>
                                <Col sm="6">
                                    <Form.Control type="text" placeholder="Jumlah Checklist" className="form-control-sm" value={dataSummary.jumlahChecklist} disabled />
                                </Col>
                            </Form.Group>
                        </Form>
                    </div>
                    <div className='col-2'>
                        <Form>
                            <Form.Group as={Row} className="form-group">
                                <Form.Label column sm="4" className="control-label align-self-center mb-0" htmlFor="searchNib">Sesuai</Form.Label>
                                <Col sm="6">
                                    <Form.Control type="text" placeholder="Jumlah Sesuai" className="form-control-sm" value={dataSummary.jumlahSesuai} disabled />
                                </Col>
                            </Form.Group>
                        </Form>
                    </div>
                    <div className='col-3'>
                        <Form>
                            <Form.Group as={Row} className="form-group">
                                <Form.Label column sm="6" className="control-label align-self-center mb-0" htmlFor="searchNib">Tidak Sesuai</Form.Label>
                                <Col sm="6">
                                    <Form.Control type="text" placeholder="Jumlah Tidak Sesuai" className="form-control-sm" value={dataSummary.jumlahTidakSesuai} disabled />
                                </Col>
                            </Form.Group>
                        </Form>
                    </div>
                </div>
            }
            {
                isUnde5Gt === 'T' && dataSummary &&
                <div className='row'>
                    <div className='col-2'>
                        <Form>
                            <Form.Group as={Row} className="form-group">
                                <Form.Label column sm="4" className="control-label align-self-center mb-0" htmlFor="searchNib">Total</Form.Label>
                                <Col sm="6">
                                    <Form.Control type="text" placeholder="Jumlah Checklist" className="form-control-sm" value={dataSummary.jumlahChecklist} disabled />
                                </Col>
                            </Form.Group>
                        </Form>
                    </div>
                    <div className='col-2'>
                        <Form>
                            <Form.Group as={Row} className="form-group">
                                <Form.Label column sm="4" className="control-label align-self-center mb-0" htmlFor="searchNib">OK</Form.Label>
                                <Col sm="6">
                                    <Form.Control type="text" placeholder="Jumlah Sesuai" className="form-control-sm" value={dataSummary.jumlahOk} disabled />
                                </Col>
                            </Form.Group>
                        </Form>
                    </div>
                    <div className='col-2'>
                        <Form>
                            <Form.Group as={Row} className="form-group">
                                <Form.Label column sm="4" className="control-label align-self-center mb-0" htmlFor="searchNib">Minor</Form.Label>
                                <Col sm="6">
                                    <Form.Control type="text" placeholder="Jumlah Tidak Sesuai" className="form-control-sm" value={dataSummary.jumlahMinor} disabled />
                                </Col>
                            </Form.Group>
                        </Form>
                    </div>
                    <div className='col-2'>
                        <Form>
                            <Form.Group as={Row} className="form-group">
                                <Form.Label column sm="4" className="control-label align-self-center mb-0" htmlFor="searchNib">Mayor</Form.Label>
                                <Col sm="6">
                                    <Form.Control type="text" placeholder="Jumlah Tidak Sesuai" className="form-control-sm" value={dataSummary.jumlahMayor} disabled />
                                </Col>
                            </Form.Group>
                        </Form>
                    </div>
                    <div className='col-2'>
                        <Form>
                            <Form.Group as={Row} className="form-group">
                                <Form.Label column sm="4" className="control-label align-self-center mb-0" htmlFor="searchNib">Kritis</Form.Label>
                                <Col sm="6">
                                    <Form.Control type="text" placeholder="Jumlah Tidak Sesuai" className="form-control-sm" value={dataSummary.jumlahKritis} disabled />
                                </Col>
                            </Form.Group>
                        </Form>
                    </div>
                    <div className='col-2'>
                        <Form>
                            <Form.Group as={Row} className="form-group">
                                <Form.Label column sm="4" className="control-label align-self-center mb-0" htmlFor="searchNib">NA</Form.Label>
                                <Col sm="6">
                                    <Form.Control type="text" placeholder="Jumlah Tidak Sesuai" className="form-control-sm" value={dataSummary.jumlahNa} disabled />
                                </Col>
                            </Form.Group>
                        </Form>
                    </div>
                </div>
            }
        </>
    )
}

export default ModalApproval